export default {
  section_heading: [],
  copy:
    'As adults, we often think that play is something best left behind in childhood.Yet there are fewer more potent ways of learning play; it helps us see new connections, understand the relationships between things and explore the world beyond the everyday.\n' +
    'React is a brilliant way of playing with new technology, new ideas and new opportunities for brands to play bigger roles in people’s lives; and businesses to create new models of revenue. ',
  citation: 'Darren Savage, Chief Strategy Officer at Tribal Worldwide London.',
  component: 'm-article-quote-v2',
}
